import type { OpenAIDailyUsage } from "../model/CopilotUsage";
import type { ProcessExecution } from "../model/Process";
import API, { responseOf } from "./base";

export const processWithCopilot = (
  taskExecutionId: string,
): Promise<ProcessExecution> =>
  responseOf(API.post(`/copilot/${taskExecutionId}/process`));

export const autofill = (
  taskExecutionId: string,
  content: string, // Link
  bias?: string,
  organization?: string,
  file = true,
): Promise<Record<string, unknown>> =>
  responseOf(
    API.post(`/copilot/${taskExecutionId}/autofill`, {
      content,
      bias,
      organization,
      file,
    }),
  );

export const getCurrentUsage = (
  organizationId: string,
): Promise<OpenAIDailyUsage[]> =>
  responseOf(API.post(`/copilot-usage/${organizationId}/current`));
